<div class="anlage-list-wrapper">
  <div class="anlage-list-filterbar">
    <cst-filter-bar [filterGroup]="filterGroup"></cst-filter-bar>
  </div>
  <div class="anlage-list-list">
    <app-list-view
      [dataSource]="dataSource"
      [columns]="columns"
      [actions]="actions"
      [compact]="false"
      [elevated]="false"
      [getRowStyle]="getRowStyle"
      id="Facilities"
      [selectionEnabled]="selectionEnabled"
      (selectionChanged)="selectionChanged.emit($event)"
      >
    </app-list-view>
  </div>
</div>

<ng-template #columnStateTemplate let-item="element">
  <app-anlage-api-monitoring-status-led
    [status]="getMonitoringStatus(item)"
  ></app-anlage-api-monitoring-status-led>
  @if (item.appointmentRequired) {
    <mat-icon
      style="font-size: 1.3rem; opacity: 0.7"
      i18n-title="@@AnlageApi_List_AppointmentRequired_Title"
      title="Tasks for this facility need an appointment arrangement"
      >perm_phone_msg</mat-icon
      >
    }
  </ng-template>

  <ng-template #filterTemplateBuildingType let-filter="filter" let-form="form">
    <ng-container [formGroup]="form">
      <frm-wawi-building-type-select
        [label]="filter.label"
        [formControlName]="filter.key"
        [allowNone]="true"
      ></frm-wawi-building-type-select>
    </ng-container>
  </ng-template>
